"use client";

import React from "react";
import DatePicker from "react-datepicker";
import { Input } from "../input.js";
import { Label } from "../label.js";
import { cn } from "@/lib/utils.js";

interface DatePickerFieldProps {
  label?: string;
  selected: Date | null;
  onChange: (date: Date | null) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  showTimeSelect?: boolean;
  timeFormat?: string;
  timeIntervals?: number;
  dateFormat?: string;
  minDate?: Date;
  maxDate?: Date;
  filterDate?: (date: Date) => boolean;
  error?: string;
}

export const DatePickerField = ({
  label,
  selected,
  onChange,
  placeholder = "Select date",
  className,
  disabled = false,
  showTimeSelect = false,
  timeFormat = "HH:mm",
  timeIntervals = 15,
  dateFormat = "MMM d, yyyy",
  minDate,
  maxDate,
  filterDate,
  error,
}: DatePickerFieldProps) => {
  return (
    <div className={cn("space-y-2", className)}>
      {label && (
        <Label className={cn(error && "text-destructive")}>{label}</Label>
      )}
      <div className="relative">
        <DatePicker
          selected={selected}
          onChange={onChange}
          placeholderText={placeholder}
          disabled={disabled}
          showTimeSelect={showTimeSelect}
          timeFormat={timeFormat}
          timeIntervals={timeIntervals}
          dateFormat={dateFormat}
          minDate={minDate}
          maxDate={maxDate}
          filterDate={filterDate}
          customInput={
            <Input
              className={cn(
                error && "border-destructive focus-visible:ring-destructive",
              )}
            />
          }
          popperClassName="z-[10001]"
          popperPlacement="bottom-start"
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
        />
      </div>
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
};
